type HekateLocalhostTestingConfig = {
  recaptchaKey?: string;
  dateAdded: number;
};

/** Reads localstorage if you are on localhost and has utilities for developing locally, e.g. recaptcha */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class LocalhostTestingUtil {
  private static readonly LOCAL_STORAGE_KEY = 'localhostTestingConfig';

  private static hasLoggedInfo = false;

  /** Return true if localhost testing is enabled */
  public static isEnabled(): boolean {
    const config = this.getConfigFromLocalStorage();
    return !!config;
  }

  /** Return the key if localhost testing is enabled and recaptchaKey is set */
  public static getRecaptchaKeyOrNull(): string | null {
    const config = this.getConfigFromLocalStorage();
    if (!config) return null;
    return config.recaptchaKey || null;
  }

  private static getConfigFromLocalStorage(): null | HekateLocalhostTestingConfig {
    try {
      if (!window || !window.localStorage) {
        return null;
      }

      if (
        document.location.hostname !== 'localhost' &&
        !document.location.hostname.endsWith('.onshape.com')
      ) {
        console.log('Not localhost, skipping localhost testing config', document.location.hostname);
        return null;
      }
      const configString = window.localStorage.getItem(this.LOCAL_STORAGE_KEY);
      if (!configString) return null;

      const config = JSON.parse(configString) as HekateLocalhostTestingConfig;
      if (!config.dateAdded) return null;

      const ttlHours = 8;
      const oneHour = 1000 * 60 * 60;
      const ttl = oneHour * ttlHours; // 8 hours
      const timeTilExpiry = (config.dateAdded + ttl - Date.now()) / oneHour;
      const isExpired = timeTilExpiry < 0;
      if (isExpired) {
        console.warn('Localhost testing config is expired. Please update it');
        return null;
      }

      if (!LocalhostTestingUtil.hasLoggedInfo) {
        LocalhostTestingUtil.hasLoggedInfo = true;

        console.log(
          'Localhost testing config',
          config,
          `Time until expiry: ${timeTilExpiry.toFixed(1)}hours`
        );
      }
      return config;
    } catch (e) {
      console.error('Error parsing localhost testing config from local storage', e);
    }
    return null;
  }
}
